import React, { useEffect, useState } from "react";
import Banner from "../../../Components/Common/Banner";
import {useNavigate, useParams } from "react-router-dom";
import BootcampBanner from "../../../Assets/images/Programs/BootcampBanner.png";
import wave_image from "../../../Assets/images/Programs/wave_lines.png";
import icon1 from "../../../Assets/images/Programs/icon1.png";
import icon2 from "../../../Assets/images/Programs/icon2.png";
import icon3 from "../../../Assets/images/Programs/icon3.png";
import icon4 from "../../../Assets/images/Programs/icon4.png";
import outstandingFeatures_bg from "../../../Assets/images/Programs/outstandingFeatures_bg.png";
import TrainedIcon from "../../../Assets/images/Programs/TrainedIcon.png";
import InContractsJobs from "../../../Assets/images/Programs/InContractsJobs.png";
import InFulltimeJob from "../../../Assets/images/Programs/InFulltimeJob.png";
import STEMExtension from "../../../Assets/images/Programs/STEMExtension.png";
import whatYouGet from "../../../Assets/images/Programs/whatYouGet.png";
import ProgramHighlightsBg from "../../../Assets/images/Programs/ProgramHighlightsBg.png";
import bullet from "../../../Assets/images/Programs/bullet-point 1.png";
import GetInTouchUs from "../../../Components/Common/GetInTouchUs";
import LeadGenerationModal from "../../../Screens/User/Programs/LeadGenerationModal";
import { GiCheckMark } from "react-icons/gi";
import { FaDownload } from "react-icons/fa";
import axios from "axios";

const icons = [icon1, icon2, icon3, icon4];

const Program = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [programData, setProgramData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const navigate = useNavigate("");

useEffect(() => {

  const fetchProgram = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/program/get-program/${id}`
      );

      setProgramData(res.data);
    } catch (error) {
      console.error("Error fetching program:", error);
    }
    finally{
      setLoading(false);
    }
  };

  fetchProgram();
}, [id]);

useEffect(()=>{
  window.scrollTo({
    top:0,
    behavior : "smooth"
  })
})

  const handleLearnMore = (plan) => {
    setSelectedPlan(plan);
    setIsModalOpen(true);
  };
  return (
    <div>
      <Banner
        pageName={programData?.title}
        bgimage={BootcampBanner}
        breadcrummbs={`Home / Knowledge / Programs / ${programData?.title}`}
      />
      <div className="lg:px-20 md:px-10 px-5 py-10 tracking-wide ">
        {/* Boost Your Job Hunt */}
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
          <div>
            <div className="border-[20px] border-primaryOrangeColor w-60 h-60 rounded-full absolute left-0 md:flex hidden z-10"></div>
            <div className=" xl:w-[80%] lg:w-full md:w-[75%] xl:h-[500px] lg:h-[400px] md:h-[500px] h-[350px] md:rounded-full overflow-hidden lg:m-0 m-auto relative z-30">
              <img
                src={programData?.programImage}
                alt={programData?.title}
                className="w-full h-full"
              />
            </div>
            <img
              src={wave_image}
              alt=""
              className="absolute mt-[-150px] xl:ml-[300px] lg:ml-[150px] md:ml-[350px] ml-[200px] animate-pulse md:flex hidden z-40"
            />
          </div>
          <div className="flex items-center">
            <div className="flex flex-col gap-2 tracking-wider text-justify">
              <p className="font-playwrite">{programData?.programHeading}</p>
              <h1 className="text-3xl font-medium">
                {programData?.programSubHeading}
              </h1>
             {Array.isArray(programData?.programDescription) &&
                programData.programDescription.map((ele, ind) => (
                  <p key={ind}>{ele}</p>
                ))}
            </div>
          </div>
        </div>
      </div>
      {/* Outstanding Features */}
      <div className="">
        <div className="lg:px-20 md:px-10 px-5 tracking-wide">
          <h1 className="text-3xl font-medium text-end">
            Outstanding Features
          </h1>
          <div className="flex justify-end">
            <div className="h-1 bg-gradient-to-l from-red-500 to-white w-[25%]"></div>
          </div>
        </div>
        <div
          style={{
            backgroundImage: `url(${outstandingFeatures_bg})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
          className="border mt-8 grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 lg:px-20 md:px-10 px-5 pt-5 pb-10 gap-2"
        >
          {programData?.outstandingFeatures?.map((ele, ind) => (
            <div
              className={`flex flex-col lg:gap-8 gap-2 ${ind % 2 !== 0 && "mt-8"
                }`}
              key={ind}
            >
              <div className="flex flex-col gap-2 bg-white px-5 py-10 rounded-lg lg:border-none border border-gray-300">
                <img
                  src={icons[ind % icons.length]}
                  alt="icons"
                  className="w-20"
                />
                <h1 className="font-medium text-xl tracking-wide">
                  {ele?.heading}
                </h1>
                <p className="text-secondaryTextColor tracking-wider text-justify">
                  {ele?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="lg:px-20 md:px-10 px-5 py-10">
        {/* Count Section */}
        <div className="grid lg:grid-cols-3 grid-cols-2 gap-8 pb-8">
          <div className="text-center">
            <img src={TrainedIcon} alt="TrainedIcon" className="m-auto" />
            <h1 className="font-bold text-3xl">3000+</h1>
            <p className="mt-1">Trained</p>
          </div>
          <div className="text-center">
            <img src={InContractsJobs} alt="TrainedIcon" className="m-auto" />
            <h1 className="font-bold text-3xl">1000+</h1>
            <p className="mt-1">In Contracts Jobs</p>
          </div>
          <div className="text-center">
            <img src={InFulltimeJob} alt="TrainedIcon" className="m-auto" />
            <h1 className="font-bold text-3xl">1000+</h1>
            <p className="mt-1">In Fulltime Job</p>
          </div>
          {/* <div className="text-center">
            <img src={STEMExtension} alt="TrainedIcon" className="m-auto" />
            <h1 className="font-bold text-3xl">3000+</h1>
            <p className="mt-1">STEM Extension   </p>
          </div> */}
        </div>
        {/* What You Get From Us ! */}
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
          <div className="flex items-center">
            <div className="flex flex-col gap-2 tracking-wider ">
              <h1 className="md:text-3xl text-xl font-medium">
                What You Get
                <b className="text-primaryOrangeColor"> From Us </b>!
              </h1>
              <p className="text-justify">{programData?.whatYouGetFromUs}</p>
            </div>
          </div>
          <div className="flex justify-end items-center">
            <img src={whatYouGet} alt="BoostYourJobHunt" className="w-[80%]" />
          </div>
        </div>
      </div>
      {/* Program Highlights */}
      <div
        style={{
          backgroundImage: `url(${ProgramHighlightsBg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
        className="h-auto lg:px-20 md:px-10 px-5 py-10 tracking-wider"
      >
        <h1 className="md:text-4xl text-2xl text-center text-white">
          Program <span className="text-primaryDarkColor">Highlights</span>
        </h1>
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-8 mt-10">
          {programData?.programHeighlights?.map((ele, ind) => (
            <div key={ind} className="flex gap-2">
              <div className="w-[5%]">
                <img src={bullet} alt="bullet" className="w-6 mt-[5px]" />
              </div>
              <p className="text-white text-lg w-[95%]">{ele}</p>
            </div>
          ))}
        </div>
        {/* <div className="mt-10 flex md:flex-row flex-col items-center justify-center gap-2">
          <button className="bg-primaryOrangeColor hover:bg-primaryDarkColor px-6 py-2 text-white rounded-md">
            Download Boucher
          </button>
          <button className="border border-primaryDarkColor hover:bg-primaryOrangeColor px-6 py-2 text-white rounded-md">
            Get Started Now
          </button>
        </div> */}
      </div>

      {/* Choose Your Plan Wisely */}
      <div className="lg:px-20 md:px-10 px-5 py-10">
        <div>
          <h1 className="text-3xl text-center font-medium">
            Choose Your <span className="text-primaryOrangeColor">Plan </span>{" "}
            Wisely
          </h1>
          <p className="text-center w-[60%] m-auto mt-2 mb-8 text-secondaryTextColor">
            Every career path is unique — and so is your journey with us. Whether you're just starting out or ready for a full-time role, our flexible plans are designed to match your goals, pace, and needs. Explore each option carefully and invest in the future you deserve.
          </p>
        </div>
        <div className="mt-12 px-4 max-w-7xl mx-auto">
          <div className={`grid gap-8 ${programData?.membershipPlan?.length === 1
            ? 'grid-cols-1 max-w-md mx-auto'
            : programData?.membershipPlan?.length === 2
              ? 'grid-cols-1 md:grid-cols-2 max-w-4xl mx-auto'
              : 'lg:grid-cols-3 md:grid-cols-2 grid-cols-1'
            }`}>
            {programData?.membershipPlan?.map((ele, ind) => (
              <div
                key={ind}
                className={`
          relative overflow-hidden rounded-2xl shadow-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl
          ${ele?.popular
                    ? "bg-gradient-to-br from-[#7a96bd] to-[#5a7ba0] text-white border-2 border-orange-400 transform scale-105"
                    : "bg-white border border-gray-200 hover:border-gray-300"
                  }
        `}
              >
                {/* Header badges */}
                <div className="flex justify-center items-center gap-3 pt-4 pb-2">
                  {/* <div className="bg-gradient-to-r from-green-400 to-green-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                    Save Up to {ele?.saveUpto}%
                  </div> */}
                  {ele?.popular && (
                    <div className="bg-gradient-to-r from-orange-400 to-orange-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg animate-pulse">
                      🔥 Most Popular
                    </div>
                  )}
                </div>

                {/* Plan content */}
                <div className="px-8 pb-8">
                  {/* Plan name */}
                  <h2 className={`text-2xl font-bold text-center mb-6 ${ele?.popular ? 'text-white' : 'text-gray-800'}`}>
                    {ele?.planName}
                  </h2>

                  {/* Price section */}
                  <div className="text-center mb-6">
                    <div className="flex items-baseline justify-center gap-1">
                      <span className={`text-2xl font-medium ${ele?.popular ? 'text-gray-200' : 'text-gray-600'}`}>
                        $
                      </span>
                      <span className={`text-6xl font-black ${ele?.popular ? 'text-white' : 'text-gray-900'}`}>
                        {ele?.price}
                      </span>
                    </div>
                  </div>

                  {/* Description */}
                  <p className={`text-justify mb-8 text-lg leading-relaxed ${ele?.popular ? 'text-gray-100' : 'text-gray-600'}`}>
                    {ele?.description}
                  </p>

                  {/* Decorative divider */}
                  <div className="flex justify-center mb-8">
                    <div className={`w-16 h-1 rounded-full ${ele?.popular ? 'bg-white/30' : 'bg-gradient-to-r from-blue-400 to-purple-500'}`}></div>
                  </div>

                  {/* Benefits section */}
                  <div className="space-y-4 mb-8">
                    {ele?.benefits?.map((benefit, benefitIndex) => (
                      <div key={benefitIndex} className="space-y-3">
                        {benefit.split(",").map((item, itemIndex) => (
                          <div key={itemIndex} className="flex items-start gap-3 group">
                            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gradient-to-r from-green-400 to-green-500 flex items-center justify-center mt-0.5">
                              <GiCheckMark size={14} className="text-white font-bold" />
                            </div>
                            <p className={`text-base font-medium leading-relaxed group-hover:translate-x-1 transition-transform duration-200 ${ele?.popular ? 'text-gray-100' : 'text-gray-700'
                              }`}>
                              {item.trim()}
                            </p>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>

                  {/* Action buttons */}
                  <div className="flex flex-col sm:flex-row gap-4 mt-8">
                    <button 
                    onClick={()=> {
                      navigate(`/enrollment?type=program&itemId=${programData._id}&packageId=${ele._id}`)
                      window.scrollTo({top:0, behavior:"smooth"})
                  }}
                    className="flex-1 bg-gradient-to-r from-orange-400 to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white font-bold py-2 px-4 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200">
                      Enroll Now
                    </button>
                    <button
                      onClick={() => handleLearnMore(ele)}
                      className={`flex-1 font-bold py-2 px-4 rounded-xl border-2 transition-all duration-200 hover:scale-105 ${ele?.popular
                        ? 'border-white text-white hover:bg-white hover:text-[#7a96bd]'
                        : 'border-gray-300 text-gray-700 hover:border-orange-400 hover:text-orange-500 hover:bg-orange-50'
                        }`}>
                      <FaDownload className="inline-block mr-2" /> Brochure
                    </button>
                  </div>
                </div>

                {/* Background decoration for popular plan */}
                {ele?.popular && (
                  <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-orange-400/20 to-transparent rounded-bl-full"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Why Choose Us */}
      <div className="lg:px-20 md:px-10 px-5 py-10">
        <h1 className="text-3xl text-center font-medium">
          Why <span className="text-primaryOrangeColor">Choose</span> Us
        </h1>
        <p className="text-center w-[60%] m-auto mt-2 text-secondaryTextColor">
          At Techmentee, we specialize in helping international students and IT & Non-IT professionals land full-time roles in the U.S. job market. Our tailored support includes one on one  technical training, personalized resume review, one-on-one interview prep, and direct marketing to top recruiters. With our expert guidance and vast employer network, we don't just prepare you — we position you to get hired
        </p>
        <div className="grid lg:grid-cols-2 grid-cols-1 mt-8 gap-8">
          {programData?.whyChooseUs?.map((ele, ind) => (
            <div key={ind} className="flex">
              <div
                className={`w-[2%] h-full ${ind % 2 === 0 ? "bg-primaryOrangeColor" : "bg-gray-500"
                  } `}
              ></div>
              <div className="w-[98%] h-full p-4">
                <h1 className="font-bold text-lg">{ele?.heading}</h1>
                <p className="tracking-wider text-secondaryTextColor text-justify">
                  {ele?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:px-20 md:px-10 px-5 py-10">
        <GetInTouchUs />
      </div>
      <LeadGenerationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedPlan={selectedPlan}
      />
    </div>
  );
};

export default Program;